import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'admin-customers',
    component: () => import(/* webpackChunkName: "users" */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: '',
            name: 'customers-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.customers-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "customers-index" */ '@/modules/admin/customers/views/Index.vue')
        },
        {
            path: 'edit/:user_id',
            name: 'customers-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'users-index',
                        },
                        transKey: 'breadcrumbs.users-index',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.users-detail',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "customers-edit" */ '@/modules/admin/customers/views/Edit.vue')
        },
    ]
}